import { CHECK_EXISTING_TEAM } from 'actions/Types';

export default function teamTaken(state = null, action) {
  if (action.type === `${CHECK_EXISTING_TEAM}_SUCCESS`) {
    return action.payload;
  }

  return state;
}
